import axios from 'axios';
import config from 'config';
import { browserSessionLock, SessionAuth } from './session';
import type { SessionTokens } from 'types/session';

export const authHttp = axios.create({ baseURL: config.backendUrl });
type Listener = (tokens: SessionTokens | null, message?: string) => void;
const listeners = new Set<Listener>();
let channel: BroadcastChannel | undefined;
try {
  if (typeof BroadcastChannel !== 'undefined') channel = new BroadcastChannel('hackerest-auth');
} catch {
  /* Storage events provide the fallback, including private browsing. */
}

export const sessionAuth = new SessionAuth(
  {
    storage: localStorage,
    lock: browserSessionLock,
    publish: () => channel?.postMessage({ type: 'auth-changed' }),
    changed: (tokens, message) => listeners.forEach(listener => listener(tokens, message)),
  },
  async refreshToken => {
    const response = await authHttp.post('/v1/auth/session/refresh', null, {
      headers: { 'x-refresh-token': refreshToken },
      timeout: 15000,
    });
    if (!response.data.success) throw new Error(response.data.message || 'Session renewal failed. Please retry.');
    return response.data.data;
  }
);
// Messages carry no credentials. Always read the authoritative atomic storage entry.
if (channel) channel.onmessage = () => sessionAuth.sync();
window.addEventListener('storage', event => {
  if (event.key === 'tokens' || event.key === null) sessionAuth.sync();
});
export function subscribeSession(listener: Listener) {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}
